module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/obwalden-e02281ea1e7f606135f0fd02a2b6db1e.jpg";